module.exports = __webpack_public_path__ + "h5/img/summer-nav4-1.ea989c7a.png";